'use client';

import PageFooter from '@/common/PageFooter';
import { SectionAnalyticsProvider } from '~/context/common/SectionAnalyticsContext';
import TestDriveCenterDisclaimers from './sections/TestDriveCenterDisclaimers';
import TestDriveCenterFaq from './sections/TestDriveCenterFaq';
import TestDriveCenterFindIt from './sections/TestDriveCenterFindIt';
import TestDriveCenterHero from './sections/TestDriveCenterHero';
import TestDriveCenterService from './sections/TestDriveCenterService';
import TestDriveCenterTopPicks from './sections/TestDriveCenterTopPicks';
import TestDriveCenterVisit from './sections/TestDriveCenterVisit';

// 'use client' is required here: SectionAnalyticsProvider uses context hooks
// without declaring its own client boundary, so this component establishes it.
export default function TestDriveCenterLanding() {
  return (
    <SectionAnalyticsProvider section="Test Drive Center">
      <div
        className="flex flex-col overflow-x-clip"
        data-testid="test-drive-center-landing"
      >
        <TestDriveCenterHero />
        <TestDriveCenterFindIt />
        <TestDriveCenterTopPicks />
        <TestDriveCenterService />
        <TestDriveCenterVisit />
        <TestDriveCenterFaq />
        <TestDriveCenterDisclaimers />
        <PageFooter />
      </div>
    </SectionAnalyticsProvider>
  );
}
